module.exports = __webpack_public_path__ + "img/音儿logo图.0d46afa7.png";